export class veeCustomValidator {

  static init(VeeValidate) {

    const check_card_number_required_Rule = "check-Card-number_required";
    const check_card_expiration_required_Rule = "check-Card_expiration_required";
    const check_card_cvc_required_Rule = "check-Card-cvc_required";
    const check_card_number_Rule = "check-Card-number";
    const check_card_expiration_Rule = "check-Card-expiration";
    const check_card_cvc_Rule = "check-Card-cvc";

    VeeValidate.Validator.extend(check_card_number_required_Rule, {
      getMessage: () => "Number of Card Info field is required.",
      validate(value) {
        if
          (
          value.number == null ||
          value.number === undefined ||
          value.number.trim() == ""
        ) {
          return false;
        } else
          return true;
      }
    });
    VeeValidate.Validator.extend(check_card_expiration_required_Rule, {
      getMessage: () => "Expiry Date of Card Info field is required.",
      validate(value) {
        if
          (
          value.expiration == null ||
          value.expiration === undefined ||
          value.expiration.trim() == ""
        ) {
          return false;
        } else
          return true;
      }
    });
    VeeValidate.Validator.extend(check_card_cvc_required_Rule, {
      getMessage: () => "CVV of Card Info field is required.",
      validate(value) {
        if
          (
          value.cvc == null ||
          value.cvc === undefined ||
          value.cvc.trim() == ""
        ) {
          return false;
        } else
          return true;
      }
    });

    VeeValidate.Validator.extend(check_card_number_Rule, {
      getMessage: () => "Number of Card Info Field is invalid.",
      validate(value) {
        if (value.isValidedNumber) {
          return true;
        } else
          return false;
      }
    });
    VeeValidate.Validator.extend(check_card_expiration_Rule, {
      getMessage: () => "Expiry Date of Card Info Field is invalid.",
      validate(value) {
        if (value.isValidedExoiredDate) {
          return true;
        } else
          return false;
      }
    });
    VeeValidate.Validator.extend(check_card_cvc_Rule, {
      getMessage: () => "CVV of Card Info Field is invalid.",
      validate(value) {
        if (value.isValidedCVC) {
          return true;
        } else
          return false;
      }
    });
  }
}